exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_wks-ext.js
// module id = 277
// module chunks = 0